import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TextField from 'components/TextField';
import Button from 'components/Button';
import { ROUTES } from 'shared/constants/routes';
import SubHeader from 'components/SubHeader';
import { Container } from 'styles/pages/orders';
import {
  linxOrderPrintifyEventDataUS,
  linxOrderPrintifyEventDataCA,
} from 'actions/orders';

const PrintifyOrders = () => {
  const dispatch = useDispatch();
  const [orderNumber, setOrderNumber] = useState('');
  const [printifyData, setPrintifyData] = useState(null);
  return (
    <Container>
      <SubHeader
        title={ROUTES.PRINTIFY_ORDERS.TITLE}
        links={[
          {
            title: ROUTES.DASHBOARD.TITLE,
            to: ROUTES.DASHBOARD.LINK,
          },
        ]}
        currentPageTitle={ROUTES.PRINTIFY_ORDERS.TITLE}
      />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          gridGap: '40px',
          margin: '20px 0',
          borderBottom: '1px solid #000',
          paddingBottom: '20px',
        }}>
        <TextField
          label='Order Number'
          value={orderNumber}
          onChange={(v) => setOrderNumber(v)}
        />
        <Button
          disabled={!orderNumber}
          title='Find Order'
          onClick={async () => {
            let plant = 'CA';
            let printifyData = await dispatch(
              linxOrderPrintifyEventDataCA(orderNumber)
            );

            if (!printifyData) {
              plant = 'US';
              printifyData = await dispatch(
                linxOrderPrintifyEventDataUS(orderNumber)
              );
            }

            setPrintifyData({ ...printifyData, plant });
          }}
        />
      </div>

      {!!printifyData?.events?.length ? (
        <div>
          <ul
            style={{
              fontSize: 16,
              lineHeight: '32px',
              color: '#000',
            }}>
            <li>PLANT : {printifyData?.plant}</li>
            {printifyData?.events?.map((e) =>
              e?.action !== 'shipped' ? (
                <li>
                  {e?.action?.toUpperCase()} : {e?.time}
                </li>
              ) : (
                <li>
                  SHIPPED : {e?.time} / {e?.tracking_number} / {e?.carrier}
                </li>
              )
            )}
          </ul>
        </div>
      ) : (
        <h2 style={{ textAlign: 'center' }}>
          This order is not present in any plant
        </h2>
      )}
    </Container>
  );
};

export default PrintifyOrders;
